<template>
  <div class="no-print" style="width: 22cm;margin: 0 auto;padding-top: 20px;" v-loading.fullscreen.lock="loading" element-loading-text="加载中，请稍后...">
    <el-affix :offset="10" >
      <el-page-header @back="router.back" >
        <template #content>
          <el-button  plain size="small" type="success" @click.prevent="onPrint">打印</el-button>
        </template>
        <template #extra>
          <p style="letter-spacing: 2px"><el-tag>报告总共：{{pageCount}}份</el-tag></p>
        </template>
      </el-page-header>
    </el-affix>
  </div>
  <div :style="{'height': pageCount * 13.9 + 'cm'}" >
    <ReportTpls :report="reports"  :count="pageCount" ></ReportTpls>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {get} from "@/assets/js/utils";
import {delay} from "lodash";
import ReportTpls from "@/components/templates/ReportTpls";
const loading = ref(true)
const route = useRoute();
const router = useRouter();
const {id: projectId} = route.params;

const reports = ref({})


const pageCount = computed(() => {
  let len = reports.value?.items?.length;
  if (!len) len = 0;
  return ((len % 8) > 0 ? 1 : 0) + parseInt(len / 8);
})


function findProject(){
  get(`/find?id=${projectId}&page=-1`, ({code, data}) => {
    if (code == 0){
      reports.value = data.data;
    }
  }, null,  () => {
    setTimeout(() => {
      loading.value = false;
    }, 1000)
  })
}

findProject()


function onPrint(){
  delay(window.print, 1000)
}



</script>

<style>
#sShot  u > span{
  font-family: "Microsoft YaHei";
  border-bottom: 1px solid #333;
}
@media print {
  .no-print{
    display: none;
  }
  .el-page-header {
    display: none;
  }
  .print{
    display: block;
  }
  .w-e-scroll{
    overflow-y: hidden !important;
  }
}
</style>